// Kashier configuration
export const KASHIER_CONFIG = {
  // Kashier Hosted Payment Page URL (official from docs)
  REDIRECT_URL: 'https://payments.kashier.io',
  
  // API endpoints
  API_BASE_URL: import.meta.env.VITE_SUPABASE_URL + '/functions/v1',
  
  // Kashier endpoints
  ENDPOINTS: {
    CREATE_CHECKOUT: '/create-kashier-checkout',
    WEBHOOK: '/kashier-webhook',
  },
  
  // Payment methods available
  PAYMENT_METHODS: [
    'card',
    'wallet',
    'bank_installments',
    'cash',
  ],
  
  // Default currency (Egyptian Pound)
  DEFAULT_CURRENCY: 'EGP',
  
  // Test mode flag
  TEST_MODE: false,
};

export const getKashierConfig = () => {
  return KASHIER_CONFIG;
};